
import React from 'react';
import Footer from '../common/Footer/index';
import Navbar from '../common/Navbar/index';
import HamburgerSideBarMenu from '../common/HamburgerSideBarMenu/index';




const KdsEmptyStation = ({ handleLogout,
    duplicateData, 
    layoutApi,
    setShowMenu,
    showMenu,
    activeScreenType, 
    History,
    handleShowRecallModal,
}) => {

    return (<>
        <Navbar
            emptyItems={true}
            showMenu={showMenu}
            setShowMenu={setShowMenu}
            toggle={false}
        />
        {
            showMenu && ( 
                <HamburgerSideBarMenu 
                    setShowMenu={setShowMenu}
                    handleLogout={handleLogout}
                    duplicateData={duplicateData} 
                    layoutApi={layoutApi} 
                    activeScreenType={activeScreenType} 
                    History={History}
                    handleShowRecallModal={handleShowRecallModal}
                    disableRecallButton={true}
                />
            )
        }
        <div className=' text-center col-12 p-1 h-80 align-content-center overflowX overflowYHidden mx-0 w-100'>
            <div className='text-center w-50' style={{height:'15vw',position:'fixed',top:'20vw',left:'25%'}}>
            <div className='font-weight-bold' style={{position:'absolute',top:'6vw',left:'20%', color:'black' }}>NO TICKETS AVAILABLE RIGHT NOW
                </div>
            </div>
        </div>
        <Footer emptyItems={true} />

    </>)
}
export default KdsEmptyStation;